/**
 * Stitched / Unstitched selector on product cards: update variant and price on pill click.
 */
(function () {
  'use strict';

  function updatePriceFromPill(pill, card) {
    if (!pill || !card) return;
    var wrapper = card.querySelector('.card-product__price-wrap');
    var priceFormatted = pill.getAttribute('data-price-formatted');
    var compareFormatted = pill.getAttribute('data-compare-formatted') || '';
    if (!wrapper || !priceFormatted) return;
    var priceDiv = wrapper.querySelector('.price');
    if (priceDiv) {
      var regularEl = wrapper.querySelector('.price__regular .price-item--regular');
      if (regularEl) regularEl.textContent = priceFormatted;
      var salePriceEl = wrapper.querySelector('.price-item--sale');
      if (salePriceEl) salePriceEl.textContent = priceFormatted;
      var compareEl = wrapper.querySelector('.price__sale s.price-item');
      if (compareEl && compareFormatted) compareEl.textContent = compareFormatted;
      var regularWrap = wrapper.querySelector('.price__regular');
      var saleWrap = wrapper.querySelector('.price__sale');
      if (compareFormatted && saleWrap && regularWrap) {
        regularWrap.style.display = 'none';
        saleWrap.style.display = '';
        priceDiv.classList.add('price--on-sale');
      } else if (regularWrap && saleWrap) {
        regularWrap.style.display = '';
        saleWrap.style.display = 'none';
        priceDiv.classList.remove('price--on-sale');
      }
    }
  }

  function init() {
    document.querySelectorAll('.card-stitched-unstitched').forEach(function (block) {
      var card = block.closest('.card-wrapper');
      var activePill = block.querySelector('.card-stitched-unstitched__pill.is-active');
      if (activePill && card) updatePriceFromPill(activePill, card);
    });

    document.body.addEventListener('click', function (e) {
      var pill = e.target.closest('.card-stitched-unstitched__pill');
      if (!pill || pill.getAttribute('aria-pressed') === 'true') return;

      var block = pill.closest('.card-stitched-unstitched');
      var cardId = block && block.getAttribute('data-card-id');
      if (!cardId) return;

      var card = document.getElementById(cardId);
      if (!card) card = block.closest('.card-wrapper');
      if (!card) return;

      var wrapper = card.querySelector('.card-product__price-wrap');
      var form = card.querySelector('form[data-type="add-to-cart-form"]');
      var variantInput = form ? form.querySelector('input[name="id"]') : null;
      var submitBtn = form ? form.querySelector('button[type="submit"][name="add"]') : null;

      /* Toggle active pill */
      block.querySelectorAll('.card-stitched-unstitched__pill').forEach(function (p) {
        p.classList.remove('is-active');
        p.setAttribute('aria-pressed', p === pill ? 'true' : 'false');
      });
      pill.classList.add('is-active');
      pill.setAttribute('aria-pressed', 'true');

      /* Update variant id */
      var variantId = pill.getAttribute('data-variant-id');
      if (variantInput) variantInput.value = variantId;

      /* Update price display */
      updatePriceFromPill(pill, card);

      /* Update add to cart button (sold out / available) */
      var available = pill.getAttribute('data-available') === 'true';
      if (submitBtn) {
        submitBtn.disabled = !available;
        var availableSpan = submitBtn.querySelector('.button-available');
        var soldOutSpan = submitBtn.querySelector('.sold-out-message');
        if (availableSpan) availableSpan.textContent = available ? (window.themeStrings && window.themeStrings.add_to_cart) || 'Add to cart' : (window.themeStrings && window.themeStrings.sold_out) || 'Sold out';
        if (soldOutSpan) soldOutSpan.classList.toggle('hidden', available);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
